/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import dynamic from "next/dynamic";

const Transliterator = dynamic(
  () =>
    import("./Transliterator").then(
      (module) => module.default
    ),
  {
    ssr: false,
  }
);
export default function IndexPage() {
  return (
    <>
      <div>
        <Transliterator />
      </div>
    </>
  );
}
